import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { normalizeDate } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';

import FileUploadField from '../../FileUploadField';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const EditMembershipSRO = ({ closeModal, id, action, userId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        id: '',
        user_id: '',
        sro_name: '',
        registration_number: '',
        protocol_number: '',
        protocol_date: '',
        date_start: '',
        date_end: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }
    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            if (!token) handleLogout();
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/get-single-sro-membership?id=${id}`)
            .then((response) => {
                setFormInfo(response.data);
                setStatus(null);
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.sro_name) {
            newErrors.sro_name = 'Обязательное поле';
        }
        if (formInfo.sro_name && (formInfo.sro_name.length < 2 || formInfo.sro_name.length > 200)) {
            newErrors.sro_name = 'Значение не может быть меньше 2 и более 200 символов';
        }

        if (!formInfo.registration_number) {
            newErrors.sro_name = 'Обязательное поле';
        }
        if (formInfo.registration_number && (formInfo.registration_number.length < 2 || formInfo.registration_number.length > 40)) {
            newErrors.sro_name = 'Значение не может быть меньше 2 и более 40 символов';
        }

        if (!formInfo.protocol_number) {
            newErrors.sro_name = 'Обязательное поле';
        }
        if (formInfo.protocol_number && (formInfo.protocol_number.length < 2 || formInfo.protocol_number.length > 40)) {
            newErrors.sro_name = 'Значение не может быть меньше 2 и более 40 символов';
        }

        if (!formInfo.protocol_date) {
            newErrors.protocol_date = 'Обязательное поле';
        }
        if (!formInfo.date_start) {
            newErrors.date_start = 'Обязательное поле';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addData = () => {
        const formData = new FormData();

        formData.append('user_id', userId);
        formData.append('sro_name', formInfo.sro_name);
        formData.append('registration_number', formInfo.registration_number);
        formData.append('protocol_number', formInfo.protocol_number);
        formData.append('protocol_date', normalizeDate(formInfo.protocol_date));
        formData.append('date_start', normalizeDate(formInfo.date_start));
        formData.append('date_end', normalizeDate(formInfo.date_end));

        if (files.certificate) {
        formData.append('file_certificate', files.certificate);
        }

        axios.put('/api/add-new-sro-membership', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(() => {
            setStatus('Новые данные добавлены');
            onSuccess();
            openTimeModal('Данные успешно добавлены', 'success');
            closeModal();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const changeData = () => {
        axios.put(`/api/change-sro-membership`, {
            id: formInfo.id,
            user_id: formInfo.user_id,
            sro_name: formInfo.sro_name,
            registration_number: formInfo.registration_number,
            protocol_number: formInfo.protocol_number,
            protocol_date: normalizeDate(formInfo.protocol_date),
            date_start: normalizeDate(formInfo.date_start),
            date_end: normalizeDate(formInfo.date_end),
        }).then(() => {
            setStatus('Данные изменены');
            onSuccess();
            openTimeModal('Данные успешно изменены', 'success');
            closeModal();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            if (action=='add') addData();
            if (action=='change') changeData();
        }
        setLoading(false);
    };

    const [files, setFiles] = React.useState({
        certificate: null,
    });
    const handleFileChange = (field) => (e) => {
        const file = e.target.files[0];
        setFiles((prev) => ({
            ...prev,
            [field]: file || null,
        }));
    };
    const handleFileReset = (field) => () => {
        setFiles((prev) => ({
            ...prev,
            [field]: null,
        }));
    };


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        {action=='add' && 'Добавление'}{action=='change' && 'Редактирование'}
                        &nbsp;сведений о членстве в СРО
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Название СРО</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.sro_name} 
                                onChange={handleChange('sro_name')} 
                                className={errorsForm.sro_name ? 'inputError' : ''}
                                placeholder='Полное название без сокращений' 
                                minLength='' 
                                maxLength='200' 
                                disabled={loading}
                                required />
                                {errorsForm.sro_name && <div className='errorUnderInput'>{errorsForm.sro_name}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Регистрационный номер в СРО</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.registration_number} 
                                onChange={handleChange('registration_number')} 
                                className={errorsForm.registration_number ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='40' 
                                disabled={loading}
                                required />
                                {errorsForm.registration_number && <div className='errorUnderInput'>{errorsForm.registration_number}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Номер протокола</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.protocol_number} 
                                onChange={handleChange('protocol_number')} 
                                className={errorsForm.protocol_number ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='40' 
                                disabled={loading}
                                required />
                                {errorsForm.protocol_number && <div className='errorUnderInput'>{errorsForm.protocol_number}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата протокола</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.protocol_date?.split('T')[0]}
                                onChange={handleChange('protocol_date')} 
                                className={errorsForm.protocol_date ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.protocol_date && <div className='errorUnderInput'>{errorsForm.protocol_date}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата вступления</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date_start?.split('T')[0]}
                                onChange={handleChange('date_start')} 
                                className={errorsForm.date_start ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.date_start && <div className='errorUnderInput'>{errorsForm.date_start}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата выхода (не обязательно)</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date_end?.split('T')[0]}
                                onChange={handleChange('date_end')} 
                                className={errorsForm.date_end ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.date_end && <div className='errorUnderInput'>{errorsForm.date_end}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Свидетельство о членстве (только в нынешнем СРО)</a>
                        <div className='labelInputRight'>
                            {action=='add' ? 
                                <div className='inputWrapper'>
                                    <FileUploadField
                                        label='Прикрепить свидетельство'
                                        file={files.certificate}
                                        buttonLabel='Прикрепить свидетельство'
                                        onChange={handleFileChange('certificate')}
                                        onReset={handleFileReset('certificate')}
                                    />
                                    {errorsForm.certificate && <div className='errorUnderInput'>{errorsForm.certificate}</div>}
                                </div>
                            :
                                <div className='panel'>
                                    <p className='description'>Изменение файла у существующей записи невозможно</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        {action=='add' && 'Добавить'} 
                        {action=='change' && 'Изменить'} 
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditMembershipSRO;